import { RequireStaff } from "@/components/RequireStaff";
import { StaffAvailabilityHub } from "@/components/staff/StaffAvailabilityHub";

export default function StaffMyAvailability() {
  return (
    <RequireStaff>
      <StaffAvailabilityHub />
    </RequireStaff>
  );
}
